import { render } from "./ProductSection.vue?vue&type=template&id=65d4f83c&scoped=true"
import script from "./ProductSection.vue?vue&type=script&lang=js"
export * from "./ProductSection.vue?vue&type=script&lang=js"

import "./ProductSection.vue?vue&type=style&index=0&id=65d4f83c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d4f83c"]])

export default __exports__